<template>
  <div class="bg">
    <img
      :src="require(`@/assets/img/loading/pcBg.jpg`)"
      class="bgm"
      v-if='!dev'
    >
    <img
      :src="require(`@/assets/img/loading/mbBg.jpg`)"
      class="bgm"
      v-if='dev'
    >
  </div>
</template>

<script>
export default {
  name: "Bg",
  computed: {
    dev() {
      return this.$store.state.dev;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.bg {
  @include wh(100%, 100%);
  .bgm {
    @include selectNone;
    @include bgObject;
  }
}
</style>

